import React from 'react';
import { GetStaticPaths, GetStaticProps } from 'next';
import fetchUtil from '../../utils/fetchUtil';
import ErrorComponent from '../../components/ErrorComponent';
import LandingPage from '../../components/OverseasEdutionFair/LandingPage';
import { CACHE_REVALIDATE } from '../../utils/constants';

const EducationFair: React.FC = (props: any) => {
  // if (!props.pageData || props.pageData.length === 0 || props.pageData[0].categoryType !== 'overseas_education_fair') {
  //   return <ErrorComponent />
  // }
  
  if (!Array.isArray(props.pageData) || props.pageData.length === 0 || props.pageData[0]?.categoryType !== 'overseas_education_fair') {
    return <ErrorComponent />
  }

  return (
    <LandingPage {...props} />
  )
}

export const getStaticPaths: GetStaticPaths = async () => {
  return { 
    paths: [], 
    fallback: 'blocking'
  };
};

export const getStaticProps: GetStaticProps = async (context) => {
  try {
    const pageData = await fetchUtil(`${process.env.NEXT_PUBLIC_API_BASE_URL}/overseas-education-fairs?slug=${context?.params?.slug}`, 'GET', {}, '', false)
    return {
      props: {
        pageData
      }
    };
  } catch (error) {
    console.error('Error fetching page data:', error);
    return {
      props: {
        pageData: []
      },
      revalidate: CACHE_REVALIDATE
    };
  }
}

export default EducationFair;